export const KM = 'km_mileage';
export const PLATE = 'license_plate_code';
export const RENAVAM = 'renavam_code';
export const CHASSIS = 'chassi_code';
export const COLOR = 'color';
export const LICENSING_UF = 'licensing_uf';
export const LICENSING_CITY = 'licensing_city';
